import { FC } from 'react';

import { Typography } from '~/common/components/Typography';
import { Loader } from '~/common/components/Loader';

import { LoadingStepContainer } from './styles';
import { SatoshiSVG } from '../../SatoshiSVG';

interface ILoadingStepProps {
  visible: boolean;
}
export const LoadingStep: FC<ILoadingStepProps> = ({ visible = false }) => {
  return (
    <LoadingStepContainer visible={visible}>
      <SatoshiSVG />
      <Loader size={100} type="bar" color="green.600" />

      <Typography.Paragraph
        size="x-large"
        color="neutral.0"
        style={{ fontWeight: 'bold' }}
      >
        Carregando
      </Typography.Paragraph>

      <Typography.Paragraph size="medium" color="neutral.200">
        Aguarde, estamos fazendo a mágica acontecer...
      </Typography.Paragraph>
    </LoadingStepContainer>
  );
};
